<template>
  <div
    class="fixed z-50 w-full h-16 max-w-lg -translate-x-1/2 bg-[#222222] border-2 border-[#d20a0a] rounded-full bottom-4 left-1/2"
  >
    <div class="grid h-full max-w-lg grid-cols-5 mx-auto">

      <router-link
        to="/events"
        data-tooltip-target="tooltip-home"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 rounded-s-full hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
            menuActive == 'eventos' ? 'bg-[#161616] font-semibold text-[#d20a0a]' : 'text-white'
          ]"
      >
        <PhCalendar class="w-7 h-7" />
        <span class="sr-only">eventos</span>
      </router-link>
      <div
        id="tooltip-home"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        Eventos
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <router-link
        to="/notices"
        data-tooltip-target="tooltip-wallet"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
            menuActive == 'noticias' ? 'bg-[#161616] font-semibold text-[#d20a0a]' : 'text-white'
          ]"
      >
        <PhNewspaper class="w-7 h-7" />
        <span class="sr-only">Wallet</span>
      </router-link>
      <div
        id="tooltip-wallet"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip"
      >
        Noticias
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <div class="flex items-center justify-center">
        <router-link
          to="/lutas"
          data-tooltip-target="tooltip-new"
          type="button"
          class="inline-flex items-center justify-center w-10 h-10 font-medium rounded-full group ring-2"
          :class="[
            menuActive == 'lives' ? 'font-semibold bg-white ring-[#d20a0a] text-[#d20a0a]' : 'bg-[#d20a0a] ring-white text-white'
          ]"
        >
          <PhVideo class="w-7 h-7" />
          <span class="sr-only">LIVES</span>
        </router-link>
      </div>
      <div
        id="tooltip-new"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        LIVES
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <router-link
        to="/plans"
        data-tooltip-target="tooltip-settings"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
            menuActive == 'ppv' ? 'bg-[#161616] font-semibold text-[#d20a0a]' : 'text-white'
          ]"
      >
        <PhCurrencyCircleDollar class="w-7 h-7" />
        <span class="sr-only">PPV</span>
      </router-link>
      <div
        id="tooltip-settings"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        PPV
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <router-link
        to="/profile"
        data-tooltip-target="tooltip-profile"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 rounded-e-full hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
            menuActive == 'perfil' ? 'bg-[#161616] font-semibold text-[#d20a0a]' : 'text-white'
          ]"
      >
        <PhUserCircle class="w-7 h-7" />
        <span class="sr-only">Perfil</span>
      </router-link>
      <div
        id="tooltip-profile"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        Perfil
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { dataShared } from '@/shared/store'
import { PhCalendar, PhCurrencyCircleDollar, PhNewspaper, PhUserCircle, PhVideo } from '@phosphor-icons/vue'
import { computed } from 'vue'

const menuActive = computed(() => dataShared.getters.getMenuActive)
</script>
